import { MaterialIcon } from '@gorila-shared-ui/components';
import { memo } from 'react';
import { Marker } from 'react-map-gl/mapbox';
import { useParams } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { useCamera } from '../../../hooks/useCamera';
import useUpdateEffect from '../../../hooks/useUpdateEffect';
import { multipleDevicesLngLatsState, multipleDeviceState } from '../../../storage/devices';
import { PrimaryVehicleIcon } from './PrimaryVehicleIcon';

function MultipleDeviceMarkers() {
  const { assetId } = useParams();
  const multipleDevice = useRecoilValue(multipleDeviceState(assetId ?? ''));
  const lngLats = useRecoilValue(multipleDevicesLngLatsState(assetId ?? ''));
  const { fitToLngLats } = useCamera();

  useUpdateEffect(() => {
    if (!lngLats.length) return;

    fitToLngLats(lngLats);
  }, [lngLats, fitToLngLats]);

  if (!multipleDevice?.devices?.length) return null;

  return (
    <>
      {multipleDevice.devices.map((secondaryDevice, index) => {
        return (
          <Marker
            latitude={secondaryDevice.position_latitude}
            longitude={secondaryDevice.position_longitude}
            rotation={secondaryDevice.isPrimary ? secondaryDevice.position_direction : undefined}
            key={index}
          >
            {secondaryDevice.isPrimary && <PrimaryVehicleIcon device={secondaryDevice} />}
            {!secondaryDevice.isPrimary && (
              <MaterialIcon
                name="sim_card"
                color={secondaryDevice.color}
              />
            )}
          </Marker>
        );
      })}
    </>
  );
}

export default memo(MultipleDeviceMarkers);
